const executiveProjectsData = [
  {
    id: "ifg-lifehub",
    title: "PT Asuransi Jiwa IFG (IFG Life) — Corporate LifeHub",
    subtitle: "Enterprise Policy Management, Underwriting & BPMN Workflow Portal",
    category: "Enterprise BUMN & Fintech",
    period: "Dec 2025 - Present",
    role: "Frontend Developer",
    liveUrl: "https://hub-asum-dev.ifg-life.id/",
    protectedUrlText: null,
    archetype: "Archetype D: Enterprise Insurance Hub & Zero-Trust Portal",
    summary:
      "The core corporate digital portal for IFG Life (`Asum Dev Hub`), managing comprehensive insurance underwriting workflows, policy administration, and actuarial analytics powered by high-performance Java Quarkus and BPMN process integration.",
    highlights: [
      "Architected secure, responsive front-end applications handling sensitive financial and medical underwriting data.",
      "Integrated Java Quarkus backend microservices with BPMN workflow engines for automated policy approval and multi-tier underwriting routing.",
      "Implemented zero-trust OIDC/OAuth2 authentication with enterprise multi-factor security layers.",
      "Reduced underwriting turnaround time threefold through automated form validation and BPMN decision pipelines."
    ],
    techStack: ["Next.js", "Tailwind CSS", "Redux Toolkit", "Java Quarkus", "BPMN Workflow", "PostgreSQL", "OIDC/OAuth2"],
    metrics: "50k+ Concurrent policyholders • 3x Faster underwriting turnaround • ISO 27001 compliant UX",
    badgeColor: "bg-blue-600 text-white"
  },
  {
    id: "my-agent-ai-suite",
    title: "My Agent — Autonomous Career & Personal Brand OS",
    subtitle: "Multi-Agent AI Pipeline, Live Zoom Video Room & ATS Resume Engine",
    category: "AI & Innovation",
    period: "Dec 2025 - Present",
    role: "Full-Stack AI Developer",
    liveUrl: "https://my-agent-mauve-omega.vercel.app/",
    protectedUrlText: null,
    archetype: "Archetype B: Multi-Agent AI Pipeline & Real-Time Audio/Video Engine",
    summary:
      "An autonomous career acceleration suite featuring multi-agent ATS resume tailoring, real-time Zoom-style AI live video mock interview room with Web Speech synthesis/recognition, auto-scrolling teleprompter, and AES-256 encrypted master data vault.",
    highlights: [
      "Engineered a multi-agent AI tailoring pipeline using Gemini 2.5/3.x for real-time ATS match scoring, keyword gap analysis, and Puppeteer PDF generation.",
      "Architected a Zoom-style Live Video Call Room featuring HTML5 webcam streams, dynamic audio waveform visualizer, and live AI subtitles.",
      "Integrated zero-cost Web Speech API (speechSynthesis for AI TTS & webkitSpeechRecognition for real-time candidate STT transcription).",
      "Built an auto-scrolling video teleprompter suite with WPM speed control and responsive storyboard creation.",
      "Secured master professional experience using AES-256-CBC encryption requiring password authorization before LLM processing."
    ],
    techStack: ["Next.js 16", "TypeScript", "Tailwind CSS", "Gemini AI", "Web Speech API", "Puppeteer", "AES-256 Security"],
    metrics: "100% Free Audio TTS/STT • Real-time Zoom AI Video Call • AES-256 Encrypted Vault • Vercel Deployed",
    badgeColor: "bg-purple-600 text-white"
  },
  {
    id: "cisea-ptba",
    title: "PT Bukit Asam Tbk — CISEA Facelift Super-App",
    subtitle: "Enterprise Mining & Operations Integration Platform",
    category: "Enterprise BUMN & Fintech",
    period: "Sep 2024 - Nov 2025",
    role: "Application Development Associate - Lead Internal MII Team",
    liveUrl: "http://cisea.bukitasam.co.id/",
    protectedUrlText: null,
    archetype: "Archetype A & B: Super-App Micro-Frontend & Unified API Gateway",
    summary:
      "A monumental enterprise integration platform unifying over 100+ disjointed operational and mining management modules into a cohesive, zero-latency Super-App ecosystem.",
    highlights: [
      "Integrated 100+ high-throughput mining, logistics, and HR modules into a single pane of glass.",
      "Architected a resilient Micro-Frontend UI layer with role-based access control (RBAC) and enterprise SSO.",
      "Engineered a high-performance API Gateway routing legacy ERP endpoints to modern reactive front-ends.",
      "Achieved 99.9% uptime across mission-critical coal production operational dashboards."
    ],
    techStack: ["React.js", "Tailwind CSS", "TypeScript", "Node.js", "Laravel API Gateway", "Docker", "Kubernetes"],
    metrics: "40% Faster operational reporting • 100+ Integrated modules • 99.9% High Availability",
    badgeColor: "bg-amber-500 text-white"
  },
  {
    id: "iot-hardware-engineering",
    title: "Electronics Hardware & IoT System Engineering",
    subtitle: "Microcontroller Firmware, Sensor Data Pipelines & Hardware Integration",
    category: "Hardware / IoT",
    period: "Dec 2023 - Jul 2024",
    role: "Application Engineering (Electronics Engineer) - Freelance",
    liveUrl: null,
    protectedUrlText: "Embedded Firmware & Hardware Schematics",
    archetype: "Archetype E: Embedded System & Real-Time Sensor Telemetry",
    summary:
      "Designed and built embedded IoT hardware solutions, programming microcontroller firmware and connecting real-time sensor telemetry to web-based monitoring dashboards.",
    highlights: [
      "Engineered microcontroller firmware (ESP32/Arduino) for real-time sensor telemetry and IoT data logging.",
      "Built WebSockets and MQTT communication pipelines for real-time sensor data streaming to web frontends.",
      "Designed custom circuit schematics and hardware prototypes for environmental and industrial telemetry."
    ],
    techStack: ["C/C++", "ESP32", "Arduino", "MQTT", "WebSockets", "Node.js", "React.js"],
    metrics: "Sub-second sensor latency • Microcontroller telemetry • Custom IoT hardware",
    badgeColor: "bg-emerald-700 text-white"
  },
  {
    id: "hcms-pusri",
    title: "PT Pupuk Sriwidjaja (Pusri) — HCMS Web App",
    subtitle: "Human Capital Management System & EAP Consultation Portal",
    category: "Enterprise BUMN & Fintech",
    period: "Aug 2023 - Nov 2024",
    role: "Fullstack Developer",
    liveUrl: null,
    protectedUrlText: "hcms.pusri.co.id (`Protected Employee Portal`)",
    archetype: "Archetype A: Enterprise SDM Dashboard & Multi-Database Orchestration",
    summary:
      "The comprehensive internal corporate portal (`hcms.pusri.co.id`) engineered for full-service employee lifecycle management, organizational structure administration, and mental health consultation across PT Pupuk Sriwidjaja Palembang.",
    highlights: [
      "Architected complete SDM lifecycle tracking including employee rotation, mutation, promotion, and role experience workflows.",
      "Engineered the Employee Assistance Program (EAP) module for secure, confidential psychological checking and mental health consultation for every employee.",
      "Built multi-RDBMS synchronization layers orchestrating data across MySQL, PostgreSQL, and Microsoft SQL Server (MSSQL).",
      "Implemented responsive asynchronous UI interactions using modern Laravel Blade, AJAX, and high-performance jQuery event handlers.",
      "Engineered core backend services using Laravel PHP, while integrating specific high-performance microservices utilizing Express.js and Go."
    ],
    techStack: ["PHP", "Laravel", "Express.js", "Go", "AJAX", "jQuery", "MySQL", "PostgreSQL", "Microsoft SQL Server (MSSQL)"],
    metrics: "100% Automated SDM rotation workflows • Confidential EAP consultation portal • Multi-database RDBMS sync",
    badgeColor: "bg-emerald-600 text-white"
  },
  {
    id: "tkno-pusri",
    title: "PT Pupuk Sriwidjaja (Pusri) — TKNO Web App",
    subtitle: "Tata Kelola & Naskah Organisasi Governance Portal",
    category: "Enterprise BUMN & Fintech",
    period: "Aug 2023 - Nov 2024",
    role: "Fullstack Developer",
    liveUrl: null,
    protectedUrlText: "Internal Corporate Governance Portal",
    archetype: "Archetype A: Decoupled SPA & REST API Governance Portal",
    summary:
      "An enterprise governance application streamlining internal employee contracts, structural documentation (`Naskah Organisasi`), and corporate compliance workflows across Pusri departments.",
    highlights: [
      "Built a fast, reactive front-end Single Page Application (SPA) utilizing modern React.js.",
      "Designed secure RESTful APIs and authentication pipelines using PHP Laravel back-end architecture.",
      "Automated internal employee contracting approval chains with role-based access restrictions.",
      "Significantly accelerated contract processing and organizational documentation archival."
    ],
    techStack: ["React.js", "PHP", "Laravel REST API", "MySQL", "Tailwind CSS"],
    metrics: "Streamlined corporate contracting • Reactive SPA user experience • Secure role segregation",
    badgeColor: "bg-teal-600 text-white"
  },
  {
    id: "ismart-education",
    title: "iSmart Education Center — Custom CMS & EdTech Platform",
    subtitle: "Interactive Student Portal & Academic Content Management",
    category: "EdTech",
    period: "Jun 2023 - Dec 2023",
    role: "Fullstack Developer",
    liveUrl: null,
    protectedUrlText: "Internal EdTech Management System",
    archetype: "Archetype F: Custom EdTech CMS & Student Analytics",
    summary:
      "Engineered a custom content management system and interactive student platform for iSmart Education Center, enabling seamless online learning, assignment tracking, and course material distribution.",
    highlights: [
      "Developed modular learning dashboards for teachers and students with real-time progress tracking.",
      "Built RESTful API backends for video lesson delivery, quiz engines, and automated grading.",
      "Designed responsive mobile-first UI components for accessibility across student devices."
    ],
    techStack: ["React.js", "Node.js", "Express.js", "MongoDB", "Tailwind CSS"],
    metrics: "100+ Active students • Automated quiz grading • Custom course CMS",
    badgeColor: "bg-sky-600 text-white"
  },
  {
    id: "freelance-mobile-web",
    title: "Freelance Web & Mobile Application Development",
    subtitle: "Cross-Platform Mobile & Web Client Projects",
    category: "Freelance Client Apps",
    period: "Jul 2022 - Oct 2023",
    role: "Freelance Front End Developer / Application Developer",
    liveUrl: null,
    protectedUrlText: "Client Proprietary Applications",
    archetype: "Archetype C: Cross-Platform Mobile & Responsive Web Suite",
    summary:
      "Delivered tailored web and mobile applications for SMEs and individual clients, specializing in responsive React user interfaces and React Native cross-platform mobile apps.",
    highlights: [
      "Developed cross-platform iOS and Android mobile apps using React Native with native performance.",
      "Built responsive web portals and landing pages optimized for SEO, speed, and conversion.",
      "Integrated payment gateways, third-party APIs, and cloud backend services (Firebase/Supabase)."
    ],
    techStack: ["React Native", "React.js", "TypeScript", "Tailwind CSS", "Firebase", "RESTful APIs"],
    metrics: "10+ Client deliverables • iOS & Android cross-platform • 99%+ CSAT",
    badgeColor: "bg-indigo-600 text-white"
  },
  {
    id: "investree-internship",
    title: "PT Investree Radhika Jaya — Student Intern Monitoring App",
    subtitle: "Fintech Enterprise HR Daily Activity & Milestone Tracker",
    category: "Enterprise BUMN & Fintech",
    period: "Jun 2022 - Jul 2022",
    role: "Fullstack Developer",
    liveUrl: null,
    protectedUrlText: "Internal Fintech HR Monitoring Portal",
    archetype: "Archetype A: Corporate HR Daily Activity Tracker & Evaluation Engine",
    summary:
      "Internal corporate management application engineered specifically for PT Investree Radhika Jaya (Financial Technology Enterprise) to monitor daily activities, track task milestones, and evaluate student intern performance across departments.",
    highlights: [
      "Designed real-time daily activity logging interfaces enabling student interns to submit shift logs and deliverables asynchronously.",
      "Built supervisor verification and milestone evaluation pipelines to track KPI completion across multiple Fintech departments.",
      "Developed comprehensive supervisor review reports with role-based access control (RBAC) ensuring data confidentiality.",
      "Implemented a clean, responsive web interface combining React front-end components with a robust PHP Laravel REST API."
    ],
    techStack: ["React.js", "PHP Laravel", "MySQL", "Tailwind CSS", "RESTful API"],
    metrics: "100% Digital daily intern activity monitoring • Streamlined KPI evaluations • Secure departmental RBAC",
    badgeColor: "bg-purple-600 text-white"
  },
  {
    id: "synapse-sjakhyakirti",
    title: "Synapse Academy & Universitas Sjakhyakirti",
    subtitle: "EdTech Leadership, Academic Portals & IT Mentorship",
    category: "Academic & Leadership",
    period: "Aug 2021 - Jan 2022",
    role: "Frontend Developer",
    liveUrl: "https://sydemy.com/",
    protectedUrlText: null,
    archetype: "Archetype F: EdTech Ecosystem & IT Leadership Mentorship",
    summary:
      "Spearheaded technical development and educational curriculum for Synapse Academy (`Sydemy.com`) and Universitas Sjakhyakirti, delivering modern web applications and developer mentorship.",
    highlights: [
      "Architected and deployed `sydemy.com`, a high-availability learning management system (LMS) serving software engineering students.",
      "Mentored developers in clean code practices, modern front-end frameworks, and responsive UI design.",
      "Collaborated with academic institutions to align IT coursework with real-world industry practices.",
      "Built responsive Single Page Applications for academic course delivery and student enrollment."
    ],
    techStack: ["React.js", "Node.js", "GraphQL", "PostgreSQL", "Tailwind CSS"],
    metrics: "500+ Engineering alumni • 100% Industry-standard curriculum • High-availability EdTech platform",
    badgeColor: "bg-rose-600 text-white"
  }
];

export default executiveProjectsData;
